(function () {
  var SECTION_SELECTOR = '.clare-section-testimonial-carousel';
  var TRACK_SELECTOR = '.clare-section-testimonial-carousel__track';
  var CARD_SELECTOR = '.clare-section-testimonial-carousel__card';
  var PREV_SELECTOR = '.clare-section-testimonial-carousel__arrow--prev';
  var NEXT_SELECTOR = '.clare-section-testimonial-carousel__arrow--next';

  var sectionState = new Map();

  function initSection(section) {
    var track = section.querySelector(TRACK_SELECTOR);
    var prevBtn = section.querySelector(PREV_SELECTOR);
    var nextBtn = section.querySelector(NEXT_SELECTOR);
    if (!track) return;

    var state = {
      autoplay: null,
      rafId: null,
      programmaticScroll: false
    };

    function getCards() {
      return Array.prototype.slice.call(track.querySelectorAll(CARD_SELECTOR));
    }

    function getCardWidth() {
      var cards = getCards();
      if (!cards.length) return 0;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.gap) || 0;
      return cards[0].offsetWidth + gap;
    }

    function scrollToDirection(direction) {
      var cardWidth = getCardWidth();
      if (!cardWidth) return;
      state.programmaticScroll = true;
      track.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
      requestAnimationFrame(function () {
        state.programmaticScroll = false;
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToDirection(-1);
        if (state.autoplay) state.autoplay.disableAutoplayPermanently();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToDirection(1);
        if (state.autoplay) state.autoplay.disableAutoplayPermanently();
      });
    }

    state.autoplay = initAutoplay(section, track, function () {
      scrollToDirection(1);
    }, state);

    sectionState.set(section.id || section, state);
  }

  function initAutoplay(section, track, advanceSlide, state) {
    var autoplayEnabled = section.dataset.autoplay === 'true';
    if (!autoplayEnabled) return null;

    var speedSeconds = parseInt(section.dataset.autoplaySpeed, 10) || 5;
    var intervalMs = speedSeconds * 1000;

    var rafId = null;
    var lastAdvance = performance.now();
    var userHasTakenControl = false;

    function disableAutoplayPermanently() {
      if (userHasTakenControl) return;
      userHasTakenControl = true;
      stop();
    }

    function tick(now) {
      if (userHasTakenControl) return;
      if (now - lastAdvance >= intervalMs) {
        advanceSlide();
        lastAdvance = now;
      }
      rafId = requestAnimationFrame(tick);
    }

    function start() {
      if (userHasTakenControl) return;
      if (rafId) return;
      lastAdvance = performance.now();
      rafId = requestAnimationFrame(tick);
    }

    function stop() {
      cancelAnimationFrame(rafId);
      rafId = null;
    }

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reducedMotion.matches) {
      return {
        start: function () {},
        stop: function () {},
        destroy: function () {},
        disableAutoplayPermanently: function () {}
      };
    }

    document.addEventListener('visibilitychange', function () {
      if (userHasTakenControl) return;
      document.hidden ? stop() : start();
    });

    if (track) {
      track.addEventListener('mouseenter', function () {
        if (!userHasTakenControl) stop();
      });
      track.addEventListener('mouseleave', function () {
        if (!userHasTakenControl) start();
      });
      track.addEventListener('focusin', disableAutoplayPermanently);
      track.addEventListener('touchstart', disableAutoplayPermanently, { passive: true });
      track.addEventListener('scroll', function () {
        if (state.programmaticScroll || userHasTakenControl) return;
        disableAutoplayPermanently();
      }, { passive: true });
    }

    reducedMotion.addEventListener('change', function (e) {
      if (userHasTakenControl) return;
      e.matches ? stop() : start();
    });

    start();

    return {
      start: start,
      stop: stop,
      destroy: function () { stop(); },
      disableAutoplayPermanently: disableAutoplayPermanently
    };
  }

  function destroySection(section) {
    var key = section.id || section;
    var state = sectionState.get(key);
    if (!state) return;
    if (state.autoplay) state.autoplay.destroy();
    cancelAnimationFrame(state.rafId);
    sectionState.delete(key);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();